export class OperationMode {
  constructor(
    public hash?: string,
    public name?: string
  ) { }

  clone() {
    return new OperationMode(
      this.hash,
      this.name
  );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/operation-mode.ts